import { RAMPS_STATE_KEY } from './ramps-reducer';

export const getRampsState = (state: any) => state[RAMPS_STATE_KEY] || { ramps: [], loading: false };
export const getRamps = (state: any) => getRampsState(state).ramps || [];
export const getRampsLoading = (state: any) => getRampsState(state).loading;

export const getAssignments = (state: any) => getRampsState(state).assignments || [];
export const getAssignmentsTotal = (state: any) => getRampsState(state).assignmentsTotal || 0;
export const getAssignmentsPages = (state: any) => getRampsState(state).assignmentsPages || 0;
export const getAssignmentsLoading = (state: any) => getRampsState(state).assignmentsLoading;
export const getApplyAssignmentLoading = (state: any) => getRampsState(state).applyLoading;
export const getDeleteAssignmentLoading = (state: any) => getRampsState(state).deleteLoading;
